import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, DomSanitizer, SafeValue } from '@angular/platform-browser';
import { NgModule, SecurityContext } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { MatButtonToggleModule } from '@angular/material/button-toggle'

import { ToastaModule } from 'ngx-toasta';

import { AppComponent } from './components/app.component';
import { HomeComponent } from './components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { VacantBedReferenceComponent } from './components/vacantbedreference/vacant-bed-reference.component';
import { AppRoutingModule } from './/app-routing.module';
import { VacantBedEditComponent } from './components/vacantbededit/vacant-bed-edit.component';
import { ErrorComponent } from './components/error/error.component';
import { VacantBedSelectComponent } from './components/vacantbededit/vacant-bed-select.component';
import { SaikiTubeEditComponent } from './components/saikitubeedit/saiki-tube-edit.component';
import { SaikiTubeReferenceComponent } from './components/saikitubereference/saiki-tube-reference.component';
import { MembersNewsEditComponent } from './components/membersnewsedit/members-news-edit.component';
import { MembersNewsReferenceComponent } from './components/membersnewsreference/members-news-reference.component';
import { DisasterComponent } from './components/disaster/disaster.component';
import { DisasterManageComponent } from "./components/disastermanage/disaster-manage.component";
import { ClinicStatusListComponent } from './components/clinicstatuslist/clinic-status-list.component';
import { ClinicStatusComponent } from './components/clinicstatus/clinic-status.component';
import { ClinicStatusEditComponent } from './components/clinicstatusedit/clinic-status-edit.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    VacantBedEditComponent,
    VacantBedReferenceComponent,
    ErrorComponent,
    VacantBedSelectComponent,
    SaikiTubeEditComponent,
    SaikiTubeReferenceComponent,
    MembersNewsEditComponent,
    MembersNewsReferenceComponent,
    DisasterComponent,
    DisasterManageComponent,
    ClinicStatusListComponent,
    ClinicStatusComponent,
    ClinicStatusEditComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    AppRoutingModule,
    ToastaModule.forRoot(),
    ReactiveFormsModule,
    MatButtonToggleModule
  ],
  providers: [
    { provide: 'BASE_URL', useFactory: getBaseUrl }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
    constructor(sanitize: DomSanitizer) {
      // IEがDOMで「null」を表示しないように、nullではなく空の文字列を返すようにsanitizeメソッドをオーバーライド
      sanitize.sanitize = function (context: SecurityContext, value: SafeValue | string | null) {
        return (sanitize as any).__proto__.sanitize.call((sanitize as any), context, value) || '';
      };
    }
}

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
